import type {EditorState} from "prosemirror-state";
import type {Node} from "prosemirror-model";
import {Transaction} from "prosemirror-state";

export const setNodeAttribute = (
    state: EditorState,
    node: Node,
    pos: number,
    attrName: string,
    value: any,
    dispatch: (tr: Transaction) => void
) => {
    if (node.type.spec!.attrs![attrName]) {
        if (node.attrs[attrName] !== value) {
            dispatch(state.tr.setNodeAttribute(pos, attrName, value));
        }
        return true;
    } else {
        return false;
    }
}